import { createReducer } from 'typesafe-actions';

import {
  IAgentWalletsState,
  TAgentWalletsAction,
  agentWalletsActionTypes,
  IAgentProfileWallet,
} from '@/features/wallets/store/types/agent-wallets.types';

const initialState: IAgentWalletsState = {
  paginateWallets: {
    elements: [],
    pagination: {
      totalPages: 0,
      currentPage: 0,
    },
  },
  isLoading: false,
};

const findWalletIndex = (elements: IAgentProfileWallet[], walletId: number) =>
  elements.findIndex((el) => el.wallet.walletId === walletId);

export const agentWalletReducer = createReducer<IAgentWalletsState, TAgentWalletsAction>(initialState)
  .handleType(agentWalletsActionTypes.SEARCH_AGENT_WALLETS, (state) => ({
    ...state,
    error: undefined,
    isLoading: true,
  }))

  .handleType(agentWalletsActionTypes.SEARCH_AGENT_WALLETS_SUCCESS, (state, action) => ({
    ...state,
    paginateWallets: {
      elements: action.wallets.map((wallet) => ({ wallet })),
      pagination: action.pagination,
    },
    isLoading: false,
    error: undefined,
  }))

  .handleType(agentWalletsActionTypes.SEARCH_AGENT_WALLETS_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_ACCOUNT_DETAILS, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      accountDetails: { isLoading: true },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_ACCOUNT_DETAILS_SUCCESS, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      accountDetails: { state: action.walletAccountDetail, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_ACCOUNT_DETAILS_FAIL, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      accountDetails: { error: action.error, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      domiciliationCertificate: { isLoading: true },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      domiciliationCertificate: { state: action.domiciliationCertificate, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE_FAIL, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      domiciliationCertificate: { error: action.error, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_BALANCE_CERTIFICATE, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      balanceCertificate: { isLoading: true },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_BALANCE_CERTIFICATE_SUCCESS, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      balanceCertificate: { state: action.balanceCertificate, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_BALANCE_CERTIFICATE_FAIL, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      balanceCertificate: { error: action.error, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_CLOSURE_CERTIFICATE, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      closureCertificate: { isLoading: true },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_CLOSURE_CERTIFICATE_SUCCESS, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      closureCertificate: { state: action.closureCertificate, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  })

  .handleType(agentWalletsActionTypes.GET_AGENT_WALLET_CLOSURE_CERTIFICATE_FAIL, (state, action) => {
    const index = findWalletIndex(state.paginateWallets.elements, action.walletId);
    if (index === -1) return state;
    const elements = [...state.paginateWallets.elements];
    elements[index] = {
      ...elements[index],
      closureCertificate: { error: action.error, isLoading: false },
    };
    return { ...state, paginateWallets: { ...state.paginateWallets, elements } };
  });
